import { combineReducers } from "redux";
import { USER_LOGOUT } from "../actions/login/types";
import login from "./login";

// Modulos de negocio agregan aqui su propio reducer conforme se construyen
// (pacientes, agenda, cargos, servicios, lentes, colegas, usuarios, etc.).
const appReducer = combineReducers({
  login,
});

// Al despachar USER_LOGOUT borramos TODO el estado en memoria del store.
const rootReducer = (state, action) => {
  if (action && action.type === USER_LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
